import { AloBaseLg, getDefaultAloBaseLg } from './AloBaseLg'

export interface AloMailTemplateLg extends AloBaseLg {        
    mtplTemplate:string
}

export const getDefaultAloMailTemplateLg = (lang=''):AloMailTemplateLg => {
    return {  
        ...getDefaultAloBaseLg(lang),
        mtplTemplate:''
    }
}